import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSuccessNotification } from '../services/common';
import {
  createDomainMonitoring,
  deleteDomainMonitoring,
} from '../services/admin';

export const useCreateDomainMonitoring = () => {
  const queryClient = useQueryClient();
  return useMutation(createDomainMonitoring, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['monitoring-domain']).then(() => {});
      showSuccessNotification('Add monitoring domain successfully');
    },
  });
};

export const useDeleteDomainMonitoring = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteDomainMonitoring, {
    onSuccess: async () => {
      queryClient.invalidateQueries(['monitoring-domain']).then(() => {});
      showSuccessNotification('Delete monitoring domain successfully');
    },
  });
};
